module.exports = __webpack_public_path__ + "static/img/banner-service.18c489f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/banner-service.jpg
// module id = tbZT
// module chunks = 0